import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return 'v1/bank-account/user-bank-accounts/validate';
}

const WHITELISTED_ERRORS = ['EC0100001', 'EC0007006', 'EC0007001', 'EC0007005', 'EC0007002'];

/**
 * @param {string} url
 */
function callbackFetch(url) {
  /** @param {import('./typedefs').RequestPayload} payload */
  return async (payload) => {
    try {
      /** @type {import('./typedefs').Response} */
      const res = await fetcher.post(url, payload);

      return res.data;
    } catch (err) {
      const resp = err?.response?.data;
      if (WHITELISTED_ERRORS.includes(resp?.err_code)) {
        return resp;
      }

      errorLogger('ERROR_API', resp?.err_message || err.message);
      throw resp;
    }
  };
}

export default function fetch() {
  const url = getUrl();

  return {
    cb: callbackFetch(url),
    key: [url],
  };
}
